<template lang="pug">
#modal-analise-elegibilidade-detalhes
    el-dialog.modal-analise-elegibilidade-detalhes(
        :visible.sync='show',
        width='80%',
        :before-close='handleCloseModal',
        :close-on-click-modal='false',
        :fullscreen='false',
        append-to-body,
        destroy-on-close
    )
        span(slot='title')
            h3.modal-analise-elegibilidade--header.mr-1 {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.analiseDeElegibilidade') }}
                .analise-elegibilidade--header__status
                    .analise-elegibilidade--header__status-diagnostico(
                        :class='statusElegibilidade[dados.elegibilidade] ? statusElegibilidade[dados.elegibilidade].classeCor : ""'
                    )
                        i.mdi.mdi-check-circle(
                            v-if='dados.elegibilidade === "ELEGIVEL"'
                        )
                        i.mdi.mdi-information.font-size-mdi(
                            v-else-if='dados.elegibilidade === "ALERTA"'
                        )
                        i.flow.flow-warning-sign(
                            v-else-if='dados.elegibilidade === "INELEGIVEL"'
                        )

                        span
                        | {{ statusElegibilidade[dados.elegibilidade] ? statusElegibilidade[dados.elegibilidade].status : '' }}

        .modal-analise-elegibilidade--body
            .direita.lista-scroll
                .modal-analise-elegibilidade--sub-title
                    i.mdi.mdi-check-circle(
                        v-if='classeDiagnosticoCar === "BAIXO"',
                        :class='statusDiagnostico[classeDiagnosticoCar] ? statusDiagnostico[classeDiagnosticoCar].corClasse : ""'
                    )
                    i.mdi.mdi-information.font-size-mdi(
                        v-else-if='classeDiagnosticoCar === "MEDIO" || classeDiagnosticoCar === "MEDIO_ALTO"',
                        :class='statusDiagnostico[classeDiagnosticoCar] ? statusDiagnostico[classeDiagnosticoCar].corClasse : ""'
                    )
                    i.flow.flow-warning-sign.mr-1(
                        v-else,
                        :class='statusDiagnostico[classeDiagnosticoCar] ? statusDiagnostico[classeDiagnosticoCar].corClasse : ""'
                    )
                    h4.direita-sub-title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.diagnosticoSocioambiental') }}
                .modal-analise-bloco
                    .modal-analise-bloco--title
                        .modal-analise-bloco--title--car
                            span CAR:
                        .modal-analise-bloco--title--descricao
                            span
                            |
                            | {{ dados.dadosDiagnostico.diagnosticoCar?.imovel.codigo }}

                    .modal-analise-bloco--conteudo
                        span.modal-analise-bloco--conteudo--interno
                            .modal-analise-bloco--conteudo--interno--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.situacaoCadasto') }}
                            | {{ exibirSatausSituacao(dados.dadosDiagnostico.diagnosticoCar?.imovel.situacao) }}

                        span.modal-analise-bloco--conteudo--interno
                            .modal-analise-bloco--conteudo--interno--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.condicaoCadastro') }}
                            | {{ dados.dadosDiagnostico.diagnosticoCar?.imovel.condicao }}

                        span.modal-analise-bloco--conteudo--interno
                            .modal-analise-bloco--conteudo--interno--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.areaImovel') }}
                            | {{ dados.dadosDiagnostico.diagnosticoCar?.imovel.areaHa }} ha
                    hr
                    .modal-analise-bloco-lista-scroll
                        el-collapse(
                            v-model='collapseAtivo',
                            @change='exibirRestricoesNoMapa',
                            accordion
                        )
                            el-collapse-item(
                                v-for='(diagnostico, index) in dados.dadosDiagnostico.diagnosticoCar?.diagnosticos',
                                v-if='diagnostico.nivelAlerta !== "BAIXO"',
                                :key='index',
                                :name='index'
                            )
                                template(slot='title')
                                    i.mr-2.flow.flow-warning-sign.mr8.custon-icon-collapse--menor(
                                        v-if='diagnostico.nivelAlerta === "ALTO"',
                                        :class='statusDiagnostico[diagnostico.nivelAlerta].corClasse'
                                    )
                                    i.mdi.mdi-information.font-size-mdi.mr8.custon-icon-collapse--menor(
                                        v-else='classeDiagnosticoCar === "MEDIO" || classeDiagnosticoCar === "MEDIO_ALTO"',
                                        :class='statusDiagnostico[diagnostico.nivelAlerta].corClasse'
                                    )
                                    span
                                    | {{ diagnostico.camada.nome }}

                                    div(v-if='diagnostico.resultados.length')
                                        el-tag.custon-tag(
                                            size='mini',
                                            type='danger'
                                        ) {{ diagnostico.resultados.length }}

                                div(
                                    v-if='diagnostico && diagnostico.resultados.length'
                                )
                                    component(
                                        ref='componente',
                                        v-bind:is='prepararComponente(diagnostico)',
                                        v-bind='prepararDadosParaComponente(diagnostico)',
                                        @aplicar-zoom-restricao='aplicarZoomRestricao'
                                    )

                                .container-sem-restricoes(
                                    v-if='diagnostico.resultados.length === 0'
                                )
                                    p {{ $t('mensagens.relatorioRastreabilidade.cadastro.naoHaRestricoes') }}

                                Fonte(
                                    :fonte='diagnostico?.camada?.fonte ? diagnostico.camada.fonte : {}',
                                    collapse-class='my-3'
                                )

                        p(
                            v-if='classeDiagnosticoCar === "BAIXO"',
                            :class='statusDiagnostico[classeDiagnosticoCar].corClasse'
                        ) Nenhuma inconformidade encontrada.

                .modal-analise-bloco.modal-analise-bloco__baixo
                    .modal-analise-bloco-cpf-cnpj
                        span.titulo {{ $t('mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.documento') }}
                        | {{ dados.cpfCnpj }}

                    .modal-analise-bloco-lista-scroll
                        el-collapse(
                            v-model='collapseAtivoPessoa',
                            accordion,
                            @change='exibirRestricoesRepresentantesNoMapa'
                        )
                            el-collapse-item(
                                v-for='(diagnostico, index) in dados.dadosDiagnostico.diagnosticoRepresentante',
                                v-if='diagnostico.nivelAlerta !== "BAIXO"',
                                :key='index',
                                :name='index'
                            )
                                template(slot='title')
                                    i.mr-2.flow.flow-warning-sign.mr8.custon-icon-collapse--menor(
                                        v-if='diagnostico.nivelAlerta === "ALTO"',
                                        :class='"vermelho"'
                                    )
                                    i.mdi.mdi-information.font-size-mdi.mr8.custon-icon-collapse--menor(
                                        v-if='diagnostico.nivelAlerta === "MEDIO_ALTO"',
                                        :class='"status-laranja"'
                                    )
                                    i.mdi.mdi-information.font-size-mdi.mr8.custon-icon-collapse--menor(
                                        v-if='diagnostico.nivelAlerta === "MEDIO"',
                                        :class='"status-amarelo"'
                                    )

                                    span {{ diagnostico.camada.nome }}

                                    div(v-if='diagnostico.resultados.length')
                                        el-tag.custon-tag(
                                            size='mini',
                                            type='danger'
                                        ) {{ diagnostico.resultados.length }}

                                div(
                                    v-if='diagnostico && diagnostico.resultados.length'
                                )
                                    component(
                                        ref='componente',
                                        v-bind:is='prepararComponente(diagnostico)',
                                        v-bind='prepararDadosParaComponente(diagnostico)',
                                        @aplicar-zoom-restricao='aplicarZoomRestricao'
                                    )

                                .container-sem-restricoes(
                                    v-if='diagnostico.resultados.length === 0'
                                )
                                    p {{ $t('mensagens.relatorioRastreabilidade.cadastro.naoHaRestricoes') }}

                                Fonte(
                                    :fonte='diagnostico?.camada?.fonte ? diagnostico.camada.fonte : {}',
                                    collapse-class='my-3'
                                )

                    p.status-sucess(v-if='!restricaoRepresentante') {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.nenhumaConformidade') }}

                .bloco-capacidade-produtiva--sub-title
                    i.mdi.mdi-check-circle.status-sucess(
                        v-if='dados.dadosBuscaSaldo.saldoCARcapacidadeProdutiva >= 0'
                    )
                    i.mdi.mdi-check-circle-outline.status-danger(v-else)
                    h4.direita-sub-title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.capacidadeProdutivaArea') }}
                .modal-analise-bloco
                    .bloco-capacidade-produtiva--conteudo
                        span.bloco-capacidade-produtiva--conteudo--interno
                            .bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.area') }}
                            | {{ dadosProdutividade.area ? formatNumber(dadosProdutividade.area) : '---' }} ha

                        .bloco-capacidade-produtiva--conteudo-baixo
                            .bloco-capacidade-produtiva--conteudo-baixo--interno
                                el-tooltip(
                                    placement='top',
                                    :content='`${$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.fonte")}: ${dadosProdutividade.fonteDados.nome}`'
                                )
                                    span
                                        i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                        span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.produtividade') }}
                                | {{ dadosProdutividade.produtividade ? dadosProdutividade.produtividade : '---' }} {{ dadosProdutividade.produtividadeUnidadeMedida }} ({{ dadosProdutividade.calculoSaca.mediaRegional ? dadosProdutividade.calculoSaca.mediaRegional : '---' }} sc/ha)

                    hr
                    // Revisado
                    .bloco-capacidade-produtiva--conteudo-baixo
                        span.bloco-capacidade-produtiva--conteudo--interno
                            el-tooltip(
                                placement='top',
                                :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.capacidadeProdXAreaConsolidade")'
                            )
                                span
                                    i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                    span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.capacidadeProdutiva') }}
                            | {{ dadosProdutividade?.capacidadeProdutiva }} t ({{ dadosProdutividade.calculoSaca.produtividade }} sc)

                        span.bloco-capacidade-produtiva--conteudo--interno
                            el-tooltip(
                                placement='top',
                                :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.valorUtilizadoCapacidade")'
                            )
                                span
                                    i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                    span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.saldoComprometido') }}
                            span.status-danger {{ dados.dadosBuscaSaldo.saldoCarComprometido }} t ({{ dados.dadosBuscaSaldo.calculoSaca.saldoCarComprometido }} sc)

                        span.bloco-capacidade-produtiva--conteudo--interno
                            el-tooltip(
                                placement='top',
                                :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.valordisponivelCapacidade")'
                            )
                                span
                                    i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                    span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.saldoDisponivel') }}
                            span.status-sucess {{ (dadosProdutividade?.capacidadeProdutiva - dados.dadosBuscaSaldo.saldoCarComprometido).toFixed(2) }} t ({{ dadosProdutividade.calculoSaca.produtividade }} sc)

                .modal-analise-bloco-bloco--title(v-if='exibeBlocoDistancia()')
                    i.mdi.mdi-check-circle.status-sucess(
                        v-if='raioPermitido() > 0'
                    )
                    i.flow.flow-warning-sign.mr-1.status-danger(v-else)
                    h4.direita-sub-title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.distancia') }}
                .modal-analise-bloco(v-if='exibeBlocoDistancia()')
                    .bloco-distancia
                        p.bloco-distancia--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.distanciaImovelAoMunicipio') }} {{ dados.dadosCalculoRaio.distanciaRaioMunicipioECar }} km
                        el-alert(
                            :title='getTitleDistanciaImovel()',
                            :type='raioPermitido() ? "success" : "error"',
                            show-icon,
                            :closable='false'
                        )

                .modal-analise-bloco-bloco--title
                    i.mdi.mdi-check-circle.status-sucess(
                        v-if='satisfazRestricaoEstado()'
                    )
                    i.flow.flow-warning-sign.mr-1.status-danger(v-else)
                    h4.direita-sub-title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.RestricaoDeEstado') }}
                .modal-analise-bloco
                    .bloco-distancia
                        el-alert(
                            :title='getTitleRestricaoImovel()',
                            :type='satisfazRestricaoEstado() ? "success" : "error"',
                            show-icon,
                            :closable='false'
                        )

            .esquerda
                .mapa-elegibilidade
                    Mapa(
                        ref='mapa',
                        :mapLayersConfigs='layersMaps',
                        :mapConfig='mapConfig',
                        :height='"93%"',
                        :idMapa='"mapaAnaliseEleigibilidadeDetalhes"'
                    )

        span(slot='footer')
            el-button(type='primary', @click='handleCloseModal') {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.voltar') }}
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

import TerraIndigena from '@/components/diagnosticoSocioambiental/TerraIndigena.vue';
import AmazoniaProtege from '@/components/diagnosticoSocioambiental/AmazoniaProtege.vue';
import AreaEmbargada from '@/components/diagnosticoSocioambiental/AreaEmbargada.vue';
import Prodes from '@/components/diagnosticoSocioambiental/Prodes.vue';
import AreaEmbargadaIcmbio from '@/components/diagnosticoSocioambiental/AreaEmbargadaIcmbio.vue';
import AreaEmbargadaSemaMt from '@/components/diagnosticoSocioambiental/AreaEmbargadaSemaMt.vue';
import AreaEmbargadaGoias from '@/components/diagnosticoSocioambiental/AreaEmbargadaGoias.vue';
import PovosComunidadesTradicionais from '@/components/diagnosticoSocioambiental/PovosComunidadesTradicionais.vue';
import Ldi from '@/components/diagnosticoSocioambiental/Ldi.vue';
import ListaAreaEmbargada from '@/components/diagnosticoSocioambiental/ListaAreaEmbargada.vue';
import ProtocoloVerdeGraos from '@/components/diagnosticoSocioambiental/ProtocoloVerdeGraos.vue';
import ListaSujaTrabalhoEscravo from '@/components/diagnosticoSocioambiental/ListaSujaTrabalhoEscravo.vue';
import ProdesCerrado from '@/components/diagnosticoSocioambiental/ProdesCerrado.vue';
import DeterAmazonia from '@/components/diagnosticoSocioambiental/DeterAmazonia.vue';
import DeterCerrado from '@/components/diagnosticoSocioambiental/DeterCerrado.vue';
import UnidadeConservacaoUs from '@/components/diagnosticoSocioambiental/UnidadeConservacaoUs.vue';
import UnidadeConservacaoPi from '@/components/diagnosticoSocioambiental/UnidadeConservacaoPi.vue';
import Queimadas from '@/components/diagnosticoSocioambiental/Queimadas.vue';
import SitiosArqueologicos from '@/components/diagnosticoSocioambiental/SitiosArqueologicos.vue';
import FaixaFronteira from '@/components/diagnosticoSocioambiental/FaixaFronteira.vue';
import PocAreaPlantadaGameleira from '@/components/diagnosticoSocioambiental/PocAreaPlantadaGameleira.vue';
import ImovelRural from '@/components/diagnosticoSocioambiental/ImovelRural.vue';
import Biomas from '@/components/diagnosticoSocioambiental/Biomas.vue';
import IncraSigefPublico from '@/components/diagnosticoSocioambiental/IncraSigefPublico.vue';
import IncraSigefPrivado from '@/components/diagnosticoSocioambiental/IncraSigefPrivado.vue';
import IncraAssentamentos from '@/components/diagnosticoSocioambiental/IncraAssentamentos.vue';
import IncraQuilombolas from '@/components/diagnosticoSocioambiental/IncraQuilombolas.vue';
import DesmatamentoMapbiomas from '@/components/diagnosticoSocioambiental/desmatamento-mapbiomas.vue';
import AreaRelevanteInteresseEcologicoArie from '@/components/diagnosticoSocioambiental/AreaRelevanteInteresseEcologicoArie.vue';
import AreaProtecaoAmbientalApa from '@/components/diagnosticoSocioambiental/AreaProtecaoAmbientalApa.vue';
import AppCamada from '@/components/diagnosticoSocioambiental/AppCamada.vue';
import ReservaLegal from '@/components/diagnosticoSocioambiental/ReservaLegal.vue';
import UnidadeConservacao from '@/components/diagnosticoSocioambiental/UnidadeConservacao.vue';
import AreaPlantadaSojaCarMapbiomas from '@/components/diagnosticoSocioambiental/AreaPlantadaSojaCarMapbiomas.vue';
import AreaEmbargadaSedamRo from '@/components/diagnosticoSocioambiental/AreaEmbargadaSedamRo.vue';
import ListaAreaEmbargadaSemaMt from '@/components/diagnosticoSocioambiental/ListaAreaEmbargadaSemaMt.vue';
import AreaEmbargadaSigaMtPoligono from '@/components/diagnosticoSocioambiental/AreaEmbargadaSigaMtPoligono.vue';
import Fonte from '@/components/diagnosticoSocioambiental/Fonte.vue';
import AreaEmbargadaGdf from '@/components/diagnosticoSocioambiental/AreaEmbargadaGdf.vue';
import AreaEmbargadaPiaui from '@/components/diagnosticoSocioambiental/AreaEmbargadaPiaui.vue';
import AreaEmbargadaSigaSemaMt from '@/components/diagnosticoSocioambiental/AreaEmbargadaSigaSemaMt.vue';
import AreaEmbargadaSigaMtPonto from '@/components/diagnosticoSocioambiental/AreaEmbargadaSigaMtPonto.vue';
import ListaAreaEmbargadaPiaui from '@/components/diagnosticoSocioambiental/ListaAreaEmbargadaPiaui.vue';
import AutoInfracaoIpaam from '../diagnosticoSocioambiental/AutoInfracaoIpaam.vue';
import AreaEmbargadaParana from '@/components/diagnosticoSocioambiental/AreaEmbargadaParana.vue';
import TermoEmbargoIpaam from '../diagnosticoSocioambiental/TermoEmbargoIpaam.vue';
import EmbargosEmergenciaisIpaam from '../diagnosticoSocioambiental/EmbargosEmergenciaisIpaam.vue';
import AutosInfracaoFiscalizacaoIpaam from '../diagnosticoSocioambiental/AutosInfracaoFiscalizacaoIpaam.vue';
import AutosEmbargosIpaamPol from '../diagnosticoSocioambiental/AutosEmbargosIpaamPol.vue';
import EmbargosRemotosIpaam from '../diagnosticoSocioambiental/EmbargosRemotosIpaam.vue';
import AutoInfracaoGoPoligono from '../diagnosticoSocioambiental/AutoInfracaoGoPoligono.vue';
import AutoInfracaoGoPonto from '../diagnosticoSocioambiental/AutoInfracaoGoPonto.vue';
import FlorestasPublicas from '@/components/diagnosticoSocioambiental/FlorestasPublicas.vue';
import AreaEmbargadaAutoInfracaoSp from '../diagnosticoSocioambiental/AreaEmbargadaAutoInfracaoSp.vue';
import AreaEmbargadaRs from '@/components/diagnosticoSocioambiental/AreaEmbargadaRs.vue';
import AreaEmbargadaGoPonto from '@/components/diagnosticoSocioambiental/AreaEmbargadaGoPonto.vue';
import AreasEmbargadasTo from '@/components/diagnosticoSocioambiental/AreasEmbargadasTo.vue';
import AutoInfracaoTo from '@/components/diagnosticoSocioambiental/AutoInfracaoTo.vue';
import EmbargosGoLista from '@/components/diagnosticoSocioambiental/EmbargosGoLista.vue';
import AutoInfracaoRs from '@/components/diagnosticoSocioambiental/AutoInfracaoRs.vue';
import QuilombolasBa from '@/components/diagnosticoSocioambiental/QuilombolasBa.vue';
import CsaCerrado from '@/components/diagnosticoSocioambiental/CsaCerrado.vue';
import AutoInfracaoPi from '@/components/diagnosticoSocioambiental/AutoInfracaoPi.vue';
import AreaEmbargadaPa from '@/components/diagnosticoSocioambiental/AreaEmbargadaPa.vue';
import Prodes2008 from '@/components/diagnosticoSocioambiental/Prodes2008.vue';
import Prodes2009 from '@/components/diagnosticoSocioambiental/Prodes2009.vue';
import Prodes2010 from '@/components/diagnosticoSocioambiental/Prodes2010.vue';
import Prodes2011 from '@/components/diagnosticoSocioambiental/Prodes2011.vue';
import Prodes2012 from '@/components/diagnosticoSocioambiental/Prodes2012.vue';
import Prodes2013 from '@/components/diagnosticoSocioambiental/Prodes2013.vue';
import Prodes2014 from '@/components/diagnosticoSocioambiental/Prodes2014.vue';
import Prodes2015 from '@/components/diagnosticoSocioambiental/Prodes2015.vue';
import Prodes2016 from '@/components/diagnosticoSocioambiental/Prodes2016.vue';
import Prodes2017 from '@/components/diagnosticoSocioambiental/Prodes2017.vue';
import Prodes2018 from '@/components/diagnosticoSocioambiental/Prodes2018.vue';
import Prodes2019 from '@/components/diagnosticoSocioambiental/Prodes2019.vue';
import Prodes2020 from '@/components/diagnosticoSocioambiental/Prodes2020.vue';
import Prodes2021 from '@/components/diagnosticoSocioambiental/Prodes2021.vue';
import Prodes2022 from '@/components/diagnosticoSocioambiental/Prodes2022.vue';
import Prodes2023 from '@/components/diagnosticoSocioambiental/Prodes2023.vue';
import Prodes2024 from '@/components/diagnosticoSocioambiental/Prodes2024.vue';
import ProdesCerrado2020 from '@/components/diagnosticoSocioambiental/ProdesCerrado2020.vue';
import ProdesCerrado2021 from '@/components/diagnosticoSocioambiental/ProdesCerrado2021.vue';
import ProdesCerrado2022 from '@/components/diagnosticoSocioambiental/ProdesCerrado2022.vue';
import ProdesCerrado2023 from '@/components/diagnosticoSocioambiental/ProdesCerrado2023.vue';
import ProdesCerrado2024 from '@/components/diagnosticoSocioambiental/ProdesCerrado2024.vue';
import AreaPlantadaDesmatamentoVegaAPartir2021 from '@/components/diagnosticoSocioambiental/AreaPlantadaDesmatamentoVegaAPartir2021.vue';
import EudrAreaPlantadaEmCoberturaFlorestal2020 from '@/components/diagnosticoSocioambiental/EudrAreaPlantadaEmCoberturaFlorestal2020.vue';
import ProdesResiduosCerrado from '@/components/diagnosticoSocioambiental/ProdesResiduosCerrado.vue';
import ProdesResiduosCaatinga from '@/components/diagnosticoSocioambiental/ProdesResiduosCaatinga.vue';
import ProdesPampa from '@/components/diagnosticoSocioambiental/ProdesPampa.vue';
import ProdesResiduosPampa from '@/components/diagnosticoSocioambiental/ProdesResiduosPampa.vue';
import ProdesAmazonia from '@/components/diagnosticoSocioambiental/ProdesAmazonia.vue';
import ProdesResiduosMataAtlantica from '@/components/diagnosticoSocioambiental/ProdesResiduosMataAtlantica.vue';
import ProdesMataAtlantica from '@/components/diagnosticoSocioambiental/ProdesMataAtlantica.vue';
import AreaEmbargadaCePonto from '@/components/diagnosticoSocioambiental/AreaEmbargadaCePonto.vue';
import AreaEmbargadaCe from '@/components/diagnosticoSocioambiental/AreaEmbargadaCe.vue';
import AreaEmbargadaIbamaPoligonoPamgia from '@/components/diagnosticoSocioambiental/AreaEmbargadaIbamaPoligonoPamgia.vue';
import AreaEmbargadaRo from '@/components/diagnosticoSocioambiental/AreaEmbargadaRo.vue';
import AreaEmbargadaRoPonto from '@/components/diagnosticoSocioambiental/AreaEmbargadaRoPonto.vue';
import PlantioDesmatamentoRedFlag from '@/components/diagnosticoSocioambiental/PlantioDesmatamentoRedFlag.vue';
import ControleDesmatamentoAmazonia from '@/components/diagnosticoSocioambiental/ControleDesmatamentoAmazonia.vue';
import ControleDesmatamentoAmazoniaPontos from '@/components/diagnosticoSocioambiental/ControleDesmatamentoAmazoniaPontos.vue';
import ControleDesmatamentoAmazoniaConsolidada from '@/components/diagnosticoSocioambiental/ControleDesmatamentoAmazoniaConsolidada.vue';
import AreaPlantadaBunge2024 from '@/components/diagnosticoSocioambiental/AreaPlantadaBunge2024.vue';
import AreaPlantadaBunge2025 from '@/components/diagnosticoSocioambiental/AreaPlantadaBunge2025.vue';
import AreaPlantadaBunge2026 from '@/components/diagnosticoSocioambiental/AreaPlantadaBunge2026.vue';
import EmbargoGoInaConsultaLista from '@/components/diagnosticoSocioambiental/EmbargoGoInaConsultaLista.vue';

import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';
import formatters from '@/utils/formatters';
const restricaoPattern =
    'https://lyra-bunge-publico.s3.amazonaws.com/restricao_pattern.gif';

export default {
    name: 'ModalAnaliseElegibilidadeDetalhes',
    components: {
        Mapa,
        TerraIndigena,
        AmazoniaProtege,
        AreaEmbargada,
        Prodes,
        AreaEmbargadaIcmbio,
        AreaEmbargadaSemaMt,
        AreaEmbargadaGoias,
        PovosComunidadesTradicionais,
        Ldi,
        ListaAreaEmbargada,
        ProtocoloVerdeGraos,
        ListaSujaTrabalhoEscravo,
        ProdesCerrado,
        DeterAmazonia,
        DeterCerrado,
        UnidadeConservacaoUs,
        UnidadeConservacaoPi,
        Queimadas,
        SitiosArqueologicos,
        FaixaFronteira,
        PocAreaPlantadaGameleira,
        ImovelRural,
        Biomas,
        IncraSigefPublico,
        IncraSigefPrivado,
        IncraAssentamentos,
        IncraQuilombolas,
        DesmatamentoMapbiomas,
        Fonte,
        AreaRelevanteInteresseEcologicoArie,
        AreaProtecaoAmbientalApa,
        AppCamada,
        ReservaLegal,
        UnidadeConservacao,
        AreaPlantadaSojaCarMapbiomas,
        AreaEmbargadaSedamRo,
        ListaAreaEmbargadaSemaMt,
        AreaEmbargadaSigaMtPoligono,
        TermoEmbargoIpaam,
        AutosInfracaoFiscalizacaoIpaam,
        AutosEmbargosIpaamPol,
        EmbargosRemotosIpaam,
        AutoInfracaoGoPoligono,
        AutoInfracaoGoPonto,
        AreaEmbargadaPiaui,
        AreaEmbargadaSigaSemaMt,
        AreaEmbargadaSigaMtPonto,
        ListaAreaEmbargadaPiaui,
        AutoInfracaoIpaam,
        EmbargosEmergenciaisIpaam,
        AreaEmbargadaParana,
        AreaEmbargadaGdf,
        FlorestasPublicas,
        AreaEmbargadaAutoInfracaoSp,
        AreaEmbargadaRs,
        AreaEmbargadaGoPonto,
        AreasEmbargadasTo,
        AutoInfracaoTo,
        CsaCerrado,
        EmbargosGoLista,
        AutoInfracaoRs,
        QuilombolasBa,
        AutoInfracaoPi,
        AreaEmbargadaPa,
        Prodes2008,
        Prodes2009,
        Prodes2010,
        Prodes2011,
        Prodes2012,
        Prodes2013,
        Prodes2014,
        Prodes2015,
        Prodes2016,
        Prodes2017,
        Prodes2018,
        Prodes2019,
        Prodes2020,
        Prodes2021,
        Prodes2022,
        Prodes2023,
        Prodes2024,
        ProdesCerrado2020,
        ProdesCerrado2021,
        ProdesCerrado2022,
        ProdesCerrado2023,
        ProdesCerrado2024,
        AreaPlantadaDesmatamentoVegaAPartir2021,
        EudrAreaPlantadaEmCoberturaFlorestal2020,
        ProdesResiduosCerrado,
        ProdesResiduosCaatinga,
        ProdesPampa,
        ProdesResiduosPampa,
        ProdesAmazonia,
        ProdesResiduosMataAtlantica,
        ProdesMataAtlantica,
        AreaEmbargadaCePonto,
        AreaEmbargadaCe,
        AreaEmbargadaIbamaPoligonoPamgia,
        AreaEmbargadaRo,
        AreaEmbargadaRoPonto,
        PlantioDesmatamentoRedFlag,
        ControleDesmatamentoAmazonia,
        ControleDesmatamentoAmazoniaPontos,
        ControleDesmatamentoAmazoniaConsolidada,
        AreaPlantadaBunge2024,
        AreaPlantadaBunge2025,
        AreaPlantadaBunge2026,
        EmbargoGoInaConsultaLista
    },

    emits: ['handleCloseModalAnaliseElegibidade'],
    props: {
        show: {
            type: Boolean
        },
        dados: {
            type: Object
        },
        raiosPermitidosPorEstado: {
            type: Array
        }
    },
    data() {
        return {
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    bufferControl: false
                },
                inspecionar: false,
                diagnostico: false
            },
            collapseAtivo: '',
            collapseAtivoPessoa: '',
            refMapa: null,
            carregandoProdutividade: false,
            dadosProdutividade: {
                estado: {
                    nome: ''
                },
                area: null,
                areaUnidadeMedida: '',
                produtividade: null,
                produtividadeUnidadeMedida: '',
                capacidadeProdutiva: null,
                capacidadeProdutivaUnidadeMedida: '',
                calculoSaca: {
                    mediaRegional: null,
                    produtividade: null
                },
                fatorProdutividade: null,
                fonteDados: {
                    id: null,
                    nome: '',
                    sigla: ''
                }
            },
            classeDiagnosticoCar: 'INDEFINIDO',
            classeDiagnostcoRepresentante: '',
            restricaoRepresentante: false,
            statusDiagnostico: {
                MEDIO_ALTO: {
                    corClasse: 'status-laranja',
                    status: 'Alerta'
                },
                MEDIO: {
                    corClasse: 'status-amarelo',
                    status: 'Alerta'
                },
                BAIXO: {
                    corClasse: 'status-sucess',
                    status: 'Conforme'
                },
                ALTO: {
                    corClasse: 'status-danger',
                    status: 'Inconforme'
                },
                INDEFINIDO: {
                    corClasse: '',
                    status: ''
                }
            },
            statusElegibilidade: {
                ELEGIVEL: {
                    classeCor: 'status-sucess',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.elegivel'
                    )
                },
                INELEGIVEL: {
                    classeCor: 'status-danger',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.inelegivel'
                    )
                },
                INDEFINIDO: {
                    classeCor: '',
                    status: ''
                },
                ALERTA: {
                    classeCor: 'status-laranja',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.comAlerta'
                    )
                }
            }
        };
    },
    computed: {
        capacidadeProdutivaFatorProdutividade() {
            return formatters.formatNumber(
                this.dadosProdutividade.fatorProdutividade + 1,
                2
            );
        }
    },
    watch: {
        show: function () {
            if (!this.show) return;
            this.mostrarTerritorioNoMapa();
            this.buscaProdutividadeCar();
            this.definirStatusCar();
            this.definirStatusRepresentante();
        }
    },
    methods: {
        handleCloseModal() {
            this.$emit('handleCloseModalAnaliseElegibidade');
        },
        mostrarTerritorioNoMapa() {
            this.refMapa = this.$refs['mapa'];

            this.layersMaps = [];

            let layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: 'Território analisado',
                geoJson:
                    this.dados.dadosDiagnostico.diagnosticoCar.imovel.geometria
            };

            this.layersMaps.push(layerTerritorio);
        },
        aplicarZoomRestricao(
            restricao,
            geometriaQueNaoEstavaDentroDasRestricoes,
            index
        ) {
            let geoJson =
                restricao.geometry ||
                restricao.geometria ||
                restricao.properties?.geometry ||
                restricao.properties?.geometria ||
                restricao.propriedade?.geometry ||
                restricao.propriedade?.geometria ||
                geometriaQueNaoEstavaDentroDasRestricoes;

            if (
                !geoJson &&
                restricao.properties?.latitude &&
                restricao.properties?.longitude
            ) {
                geoJson = {
                    type: 'Point',
                    coordinates: [
                        restricao.properties.longitude,
                        restricao.properties.latitude
                    ]
                };
            }
            this.refMapa = this.$refs['mapa'];

            this.refMapa.aplicarZoomGeoJson(geoJson);
        },
        prepararComponente(diagnostico) {
            if (!diagnostico.camada.codigo) return;
            if (diagnostico.camada.codigo === 'Áreas embargadas') {
                diagnostico.camada.nome += ' (IBAMA)';
            }
            if (diagnostico.camada.codigo === 'CONTROLE_DESMATAMENTO_AMAZONIA_PONTOS') {
                diagnostico.camada.nome = 'Controle Desmatamento Amazônia - Lista';
            }
            if (diagnostico.camada.codigo === 'APP') {
                return 'appCamada';
            }

            const partes = diagnostico.camada.codigo.split('_');
            const resultado = partes.map(parte => {
                return (
                    parte.charAt(0).toUpperCase() + parte.slice(1).toLowerCase()
                );
            });
            return resultado.join('');
        },
        prepararDadosParaComponente(diagnostico) {
            return {
                restricoes: diagnostico.resultados,
                geometria: diagnostico.geometria,
                habilitarZoomRestricao: true,
                cpfCnpj: diagnostico.cpfCnpj
            };
        },
        removerRestricoesNoMapa() {
            this.layersMaps = this.layersMaps.filter(
                layer => layer.name === `Território analisado`
            );
        },
        async buscaProdutividadeCar() {
            this.carregandoProdutividade = true;
            this.dadosProdutividade = {
                estado: {
                    nome: ''
                },
                area: null,
                areaUnidadeMedida: '',
                produtividade: null,
                produtividadeUnidadeMedida: '',
                capacidadeProdutiva: null,
                capacidadeProdutivaUnidadeMedida: '',
                calculoSaca: {
                    mediaRegional: null,
                    produtividade: null
                },
                fatorProdutividade: null,
                fonteDados: {
                    id: null,
                    nome: '',
                    sigla: ''
                }
            };
            try {
                const numeroContrato = this.$route?.params?.numeroContrato;
                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.buscaProdutividadeCar(
                        this.dados.dadosBuscaSaldo.codigoCar,
                        this.dados.dadosBuscaSaldo.cultura.codigo,
                        this.dados.safraNome,
                        numeroContrato,
                        true
                    );
                this.dadosProdutividade = data;
            } catch (error) {}
            this.carregandoProdutividade = false;
        },
        definirStatusRepresentante() {
            if (this.dados.dadosDiagnostico.diagnosticoRepresentante.length) {
                this.restricaoRepresentante = false;
                this.dados.dadosDiagnostico.diagnosticoRepresentante.forEach(
                    diagnostico => {
                        if (diagnostico.nivelAlerta !== 'BAIXO') {
                            this.restricaoRepresentante = true;
                        }
                    }
                );
            }
        },
        definirStatusCar() {
            this.classeDiagnosticoCar = 'INDEFINIDO';
            let laranja = false;
            let vermelho = false;
            let amarelo = false;
            if (
                this.dados.dadosDiagnostico.diagnosticoCar.diagnosticos.length
            ) {
                this.dados.dadosDiagnostico.diagnosticoCar.diagnosticos.forEach(
                    diagnostico => {
                        if (diagnostico.nivelAlerta === 'ALTO') {
                            vermelho = true;
                        }
                        if (diagnostico.nivelAlerta === 'MEDIO') {
                            amarelo = true;
                        }
                        if (diagnostico.nivelAlerta === 'MEDIO_ALTO') {
                            laranja = true;
                        }
                    }
                );
            }
            if (vermelho) {
                this.classeDiagnosticoCar = 'ALTO';
            } else if (laranja) {
                this.classeDiagnosticoCar = 'MEDIO_ALTO';
            } else if (amarelo) {
                this.classeDiagnosticoCar = 'MEDIO';
            } else {
                this.classeDiagnosticoCar = 'BAIXO';
            }
        },
        exibirSatausSituacao(situacao) {
            switch (situacao) {
                case 'AT':
                    return 'Ativo';
                case 'CA':
                    return 'Cancelado';
                case 'PE':
                    return 'Pendente';
                default:
                    return situacao;
            }
        },
        formatNumber(number) {
            return formatters.formatNumber(number, 2);
        },
        exibirRestricoesNoMapa() {
            this.removerRestricoesNoMapa();
            if (
                typeof this.collapseAtivo === 'string' &&
                this.collapseAtivo === ''
            ) {
                return;
            }

            const areas =
                this.dados.dadosDiagnostico.diagnosticoCar.diagnosticos[
                    this.collapseAtivo
                ].resultados.filter(
                    resultado =>
                        resultado.geometria ||
                        resultado.geometry ||
                        (resultado.properties.latitude &&
                            resultado.properties.longitude)
                );

            const opacidade = 0.5;

            areas.forEach((area, index) => {
                const geometria = area.geometria || area.geometry;

                if (geometria) {
                    const name = `AreaDiagnostico-${this.collapseAtivo}-${index}`;
                    if (!this.layersMaps.find(layer => layer.name === name)) {
                        this.layersMaps.push({
                            name,
                            indexDiagnostico: this.collapseAtivo,
                            group: `grupo-restricoes-${this.collapseAtivo}`,
                            style: {
                                color: '#c20a0a',
                                weight: 1,
                                fill: 'url(' + restricaoPattern + ')',
                                opacity: opacidade,
                                fillOpacity: opacidade
                            },
                            geoJson: geometria
                        });
                    }

                    let icon = null;

                    if (geometria.type !== 'Point') {
                        icon = L.icon({
                            iconUrl:
                                'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                            iconSize: [18, 18]
                        });
                        const nameCentroid = `CentroidDiagnostico-${this.collapseAtivo}-${index}`;
                        if (
                            !this.layersMaps.find(
                                layer => layer.name === nameCentroid
                            )
                        ) {
                            this.layersMaps.push({
                                name: nameCentroid,
                                group: `grupo-centroid-${this.collapseAtivo}`,
                                indexDiagnostico: this.collapseAtivo,
                                icon,
                                geoJson: centroidFromGeoJSON.get(geometria)
                            });
                        }
                    }
                } else {
                    const { properties } = area;
                    if (
                        properties &&
                        properties.latitude &&
                        properties.longitude
                    ) {
                        const name = `AreaDiagnostico-${this.collapseAtivo}-${index}`;
                        if (
                            !this.layersMaps.find(layer => layer.name === name)
                        ) {
                            this.layersMaps.push({
                                name,
                                indexDiagnostico: this.collapseAtivo,
                                group: `grupo-restricoes-${this.collapseAtivo}`,
                                style: {
                                    color: '#c20a0a',
                                    weight: 10,
                                    fill: 'url(' + restricaoPattern + ')',
                                    opacity: 0.5,
                                    fillOpacity: opacidade
                                },
                                geoJson: {
                                    type: 'Point',
                                    coordinates: [
                                        properties.longitude,
                                        properties.latitude
                                    ]
                                }
                            });
                        }
                    }
                }
            });
        },
        getTitleExcecaoEstado() {
            return this.$t(
                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.TerritorioForaDoEstadoPermitido'
            );
        },
        exibirRestricoesRepresentantesNoMapa() {
            this.removerRestricoesNoMapa();
            if (
                typeof this.collapseAtivoPessoa === 'string' &&
                this.collapseAtivoPessoa === ''
            ) {
                return;
            }

            const areas = this.dados.dadosDiagnostico.diagnosticoRepresentante[
                this.collapseAtivoPessoa
            ].resultados.filter(
                resultado =>
                    resultado.geometria ||
                    resultado.geometry ||
                    (resultado.properties.latitude &&
                        resultado.properties.longitude)
            );

            const opacidade = 0.5;

            areas.forEach((area, index) => {
                const geometria = area.geometria || area.geometry;

                if (geometria) {
                    const name = `AreaDiagnosticoRepresentante-${this.collapseAtivo}-${index}`;
                    if (!this.layersMaps.find(layer => layer.name === name)) {
                        this.layersMaps.push({
                            name,
                            indexDiagnostico: this.collapseAtivoPessoa,
                            group: `grupo-restricoes-representante-${this.collapseAtivoPessoa}`,
                            style: {
                                color: '#c20a0a',
                                weight: 1,
                                fill: 'url(' + restricaoPattern + ')',
                                opacity: opacidade,
                                fillOpacity: opacidade
                            },
                            geoJson: geometria
                        });
                    }

                    let icon = null;

                    if (geometria.type !== 'Point') {
                        icon = L.icon({
                            iconUrl:
                                'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                            iconSize: [18, 18]
                        });
                        const nameCentroid = `CentroidDiagnosticoRepresentante-${this.collapseAtivoPessoa}-${index}`;
                        if (
                            !this.layersMaps.find(
                                layer => layer.name === nameCentroid
                            )
                        ) {
                            this.layersMaps.push({
                                name: nameCentroid,
                                group: `grupo-centroid-representante-${this.collapseAtivoPessoa}`,
                                indexDiagnostico: this.collapseAtivoPessoa,
                                icon,
                                geoJson: centroidFromGeoJSON.get(geometria)
                            });
                        }
                    }
                } else {
                    const { properties } = area;
                    if (
                        properties &&
                        properties.latitude &&
                        properties.longitude
                    ) {
                        const name = `AreaDiagnosticoRepresentante-${this.collapseAtivoPessoa}-${index}`;
                        if (
                            !this.layersMaps.find(layer => layer.name === name)
                        ) {
                            this.layersMaps.push({
                                name,
                                indexDiagnostico: this.collapseAtivo,
                                group: `grupo-restricoes-representante-${this.collapseAtivoPessoa}`,
                                style: {
                                    color: '#c20a0a',
                                    weight: 10,
                                    fill: 'url(' + restricaoPattern + ')',
                                    opacity: 0.5,
                                    fillOpacity: opacidade
                                },
                                geoJson: {
                                    type: 'Point',
                                    coordinates: [
                                        properties.longitude,
                                        properties.latitude
                                    ]
                                }
                            });
                        }
                    }
                }
            });
        },
        raioPermitido() {
            if (
                this.dados.dadosRestricaoEstado?.possuiRestricaoEstado &&
                this.dados.dadosRestricaoEstado?.aplicarTodoEstado
            ) {
                return (
                    this.dados.dadosRestricaoEstado?.siglaEstadoCar ===
                    this.dados.dadosRestricaoEstado?.siglaEstadoPermitido
                );
            }
            if (!this.dados.dadosCalculoRaio.distanciaRaioMunicipioECar) {
                return true;
            }
            return (
                this.dados.dadosCalculoRaio.distanciaRaioMunicipioECar <=
                this.dados.dadosCalculoRaio.distanciaPermitida
            );
        },
        possuiRestricaoEstado() {
            if (this.dados.dadosRestricaoEstado?.possuiRestricaoEstado) {
                return true;
            }
            return false;
        },
        possuiRestricaoMunicipio() {
            if (this.dados.dadosRestricaoMunicipio?.possuiRestricaoMunicipio) {
                return true;
            }
            return false;
        },
        satisfazRestricaoEstado() {
            if (
                !this.dados.dadosRestricaoEstado?.possuiRestricaoEstado ||
                this.dados.dadosRestricaoEstado?.siglaEstadoCar ===
                    this.dados.dadosRestricaoEstado?.siglaEstadoPermitido
            ) {
                return true;
            }
            return false;
        },
        satisfazRestricaoMunicipio() {
            if (
                !this.dados.dadosRestricaoMunicipio?.possuiRestricaoMunicipio ||
                this.dados.dadosRestricaoMunicipio?.municipioCar ===
                    this.dados.dadosRestricaoMunicipio?.municipioPermitido
            ) {
                return true;
            }
            return false;
        },
        exibeBlocoDistancia() {
            if (
                this.satisfazRestricaoEstado() &&
                !this.dados.dadosRestricaoEstado?.aplicarTodoEstado
            ) {
                return true;
            }
            return false;
        },
        getTitleRestricaoImovel() {
            if (this.possuiRestricaoEstado()) {
                if (this.satisfazRestricaoEstado()) {
                    return this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.TerritorioDentroDoEstadoPermitido'
                    );
                } else {
                    return this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.TerritorioForaDoEstadoPermitido'
                    );
                }
            } else {
                return this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.ContratoNaoPossuiRestricaoDeEstado'
                );
            }
        },
        getTitleRestricaoMunicipio() {
            if (this.possuiRestricaoMunicipio()) {
                if (this.satisfazRestricaoMunicipio()) {
                    return this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.TerritorioDentroDoMunicipioPermitido'
                    );
                } else {
                    return this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.TerritorioForaDoMunicipioPermitido'
                    );
                }
            } else {
                return this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.ContratoNaoPossuiRestricaoDeMunicipio'
                );
            }
        },
        getTitleDistanciaImovel() {
            if (this.raioPermitido()) {
                return this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.distanciaDentroDoLimite'
                );
            }

            return (
                this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.distanciaExcedidaDoLimite'
                ) +
                this.dados.dadosCalculoRaio.distanciaPermitida +
                'km.'
            );
        },

        getLimiteRaio() {
            return this.dados.dadosCalculoRaio.distanciaPermitida;
        }
    }
};
</script>
<style lang="scss">
.modal-analise-elegibilidade-detalhes {
    .status-amarelo {
        color: #bfae19;
        font-weight: 600;
    }

    .status-laranja {
        color: var(--warning);
        font-weight: 600;
    }

    .status-danger {
        color: var(--danger);
        font-weight: 600;
    }

    .status-sucess {
        color: var(--green);
        font-weight: 600;
    }

    .el-dialog__body {
        padding: 14px 15px;
        height: 515px;
    }

    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: #f6f6f6;
        color: #3b3b3b;
        padding-bottom: 12px;
        padding-top: 12px;
    }

    .el-dialog__headerbtn {
        top: 10px;
    }

    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }

    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;

        .analise-elegibilidade--header__status {
            margin-left: 4px;
            display: flex;
            gap: 40px;

            .analise-elegibilidade--header__status-diagnostico {
                span {
                    margin-left: 4px;
                }
            }
        }
    }

    .direita-sub-title {
        font-weight: bold;
        color: #3b3b3b;
        font-size: 15px;
        margin-bottom: 8px;
        margin-top: 8px;
    }

    .modal-analise-elegibilidade--sub-title,
    .bloco-capacidade-produtiva--sub-title {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .modal-analise-elegibilidade--body {
        height: 495px;
        display: flex;
        justify-content: space-between;
        gap: 1%;

        .direita.lista-scroll {
            width: 52%;
            max-height: 495px;
            overflow: auto;
        }

        .esquerda {
            width: 47%;

            .mapa-elegibilidade {
                height: 100%;
                min-height: 568px;
                border-radius: 4px;
                overflow: hidden;
                margin: 0px 0 9px 0;
            }

            .bloco-distancia {
                min-height: 116px;
            }
        }

        .modal-analise-bloco-lista-scroll {
            overflow-y: auto;
            max-height: 230px;
            padding: 5px 0px;
        }

        .modal-analise-bloco-bloco--title {
            display: flex;
            align-items: center;
            gap: 4px;
        }

        .modal-analise-bloco {
            background: #f7f6f6;
            border-radius: 5px;
            padding: 12px 11px;

            &.modal-analise-bloco__baixo {
                margin-top: 18px;
            }

            .modal-analise-bloco-cpf-cnpj {
                .titulo {
                    color: #183b57;
                    font-weight: bold;
                    margin-right: 5px;
                }
            }

            .modal-analise-bloco--title {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #3b3b3b;
                margin-bottom: 13px;
                gap: 4px;
            }

            .container-sem-restricoes {
                p {
                    margin-left: 20px;
                }
            }

            .modal-analise-bloco--conteudo,
            .bloco-capacidade-produtiva--conteudo {
                display: flex;
                gap: 20px;
                justify-content: flex-start;
                flex-wrap: wrap;
            }

            .bloco-capacidade-produtiva--conteudo--interno,
            .bloco-capacidade-produtiva--conteudo--interno {
                margin-bottom: 5px;
                display: flex;
                flex-direction: column;
            }

            .modal-analise-bloco--conteudo--interno--title,
            .bloco-capacidade-produtiva--conteudo--title,
            .bloco-distancia--conteudo--title,
            .modal-analise-bloco--title--car {
                color: #183b57;
                font-weight: bold;
            }

            .bloco-capacidade-produtiva--conteudo-baixo {
                display: flex;
                justify-content: flex-start;
                gap: 20px;
                flex-wrap: wrap;

                .bloco-capacidade-produtiva--conteudo-baixo--interno {
                    display: flex;
                    flex-direction: column;
                }
            }
        }

        .el-collapse-item__header {
            background-color: #f7f6f6;
            color: #3b3b3b;
        }

        .el-collapse-item__content {
            background: #f7f6f6;
        }

        .custon-icon-collapse--grande {
            font-size: 18px;
        }

        .custon-icon-collapse--menor {
            font-size: 13px;
        }
    }

    .el-dialog.is-fullscreen {
        .modal-analise-bloco-lista-scroll {
            max-height: 550px !important;
        }
    }

    .modal-anotacao-footer {
        display: flex;
        justify-content: space-between;
    }

    .el-alert__title {
        color: #3b3b3b;
        font-weight: bold;
    }

    i.custon-icon-collapse--menor {
        margin-right: 4px;
    }

    .lista-scroll::-webkit-scrollbar-thumb {
        background: var(--primary);
        border-radius: 10px;
        border: 3px solid var(--white);
    }

    i {
        font-weight: 600;
    }
}
</style>
